export enum FileType {
  OriginalFile = 1,
  ExtractedHtmlFile = 2,
  IncomingProductionImage = 3,
  IncomingProductionText = 4,
  NormalizedTiff = 5,
  NormalizedPdf = 6,
  NormalizedTranslatedFile = 7,
  RedactionImage = 8,
  RedactedPdf = 9,
  AnnotationImage = 10,
  AnnotatedPdf = 11,
  TranscribedFile = 12,
  ImageLabelFile = 13,
  EntityAnalysisFile = 14,
  IncomingProductionPdf = 15,
  ExtractedText = 16,
  RedactedNativeFile = 17,
  OutgoingProductionImage = 20,
  OutgoingProductionBatesStampedPdf = 21,
  OutgoingProductionText = 22,
  OutgoingProductionLoadfileLexbe = 23,
  OutgoingProductionLoadfileSummation = 24,
  OutgoingProductionLoadfilePipedSeparatedValues = 25,
  OutgoingProductionLoadfileConcordance = 26,
  OutgoingProductionImageLoadFile = 27,
  OutgoingProductionLoadfileTabSeparatedValues = 28,
  OutgoingProductionPlaceholderOriginal = 29,
  LegacyDownloadZip = 30,
  OutgoingBriefcaseBatesStampedPdf = 31,
  OutgoingBriefcaseRedactedPdf = 32,
  OutgoingBriefcasePdfMerged = 33,
  OutgoingBriefcaseRedactedMerged = 34,
  OutgoingBriefcaseAnnotatedPdf = 35,
  OutgoingBriefcaseAnnotatedMerged = 36,
  OutgoingBriefcaseZipped = 37,
  ArchiveImage = 40,
  ArchiveText = 41,
  ArchiveJobLoadfileLexbe = 43,
  ArchiveJobLoadfileSummation = 44,
  ArchiveJobLoadfilePipedSeparatedValues = 45,
  ArchiveJobLoadfileConcordance = 46,
  ArchiveJobImageLogFile = 47,
  ArchiveJobLoadfileTabSeparatedValues = 48,
  AIResponseFile = 60
}
